<template>
  <div style="height: calc(100vh - 196px);">
    <vxe-toolbar
      id="toolbarId_ba8"
      :custom="{storage: true}"
      export
      :refresh="{query: RefreshList}"
    >
      <template v-slot:buttons>
        <el-button
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="!parentData.isDetail"
          @click="applyToVehicleTeam"
        >
          申请加入
        </el-button>
        <el-button @click="funcExport">
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      show-footer
      highlight-current-row
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :data="tableData"
      :checkbox-config="{highlight: true}"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column
        type="checkbox"
        width="60"
        fixed="left"
      />
      <vxe-table-column>
        <vxe-table-column
          field="linkMan"
          title="车队名称"
          min-width="60"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.linkMan"
            placeholder="请输入车队名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="name"
          title="联系人"
          min-width="60"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.name"
            placeholder="请输入联系人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="phone"
          title="手机号"
          min-width="60"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入手机号"
            clearable
          />
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import request from '@/utils/request'
export default {
  name: 'ApplyToVehicleTeam',
  components: {

  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          isDetail: false
        };
      }
    }
  },
  data() {
    return {
      exportObj:{
        exportUrl:"/ntocc-basic-api/driver/exportApplyTeamList",//导出接口
        name:'申请加入车队'
      },
      message: '',
      loading: false,
      tableData: [],
      copy: false,
      // checkedRowArray: [],
      listQuery: {
        partyCode: '',
        linkMan: '',
        name: '',
        phone: '',
        driverType: 1,
        pageNum: 1,
        pageSize: 20,
        sortField: '',
        sortType: '',
        total: 0
      },
    }
  },
  created() {
    this.listQuery.partyCode = this.$route.query.partyCode
    // this.findList()
  },
  methods: {
    findList() {
      this.loading = true
      return new Promise(resolve => {
        request({
          url: '/ntocc-basic-api/driver/applyTeamList',
          method: 'get',
          params: this.listQuery
        }).then(response => {
          this.tableData = response.data.records
          this.listQuery.total = response.data.total
          this.loading = false
          resolve();
        })
      })
    },
    // 加入车队
    applyToVehicleTeam() {
      // 获取所有选中的复选框
      this.checkedRowArray = this.$refs.xTable.getSelectRecords()
      if (!this.checkedRowArray || this.checkedRowArray.length === 0) {
        this.$message({ message: '请选择要加入的车队', type: 'warning' })
      } else {
        const checkCodeArray = []
        this.checkedRowArray.forEach(item => {
          checkCodeArray.push(item.partyCode)
        })
        const checkPartyCodes = checkCodeArray.join(',')
        request({ url: '/ntocc-basic-api/inviteApplyRecord/batchApply', method: 'post', params: { teamCodes: checkPartyCodes }}).then(response => {
          this.$message({ message: '申请成功', type: 'success' })
          this.findList()
        })
      }
    },

  }
}
</script>

<style>
    
</style>
